'use strict';

module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/remarkable/index.js
// module id = 1140
// module chunks = 0